import moment from "moment";

export const MONTHS = [
  { value: 1, label: "Jan" },
  { value: 2, label: "Feb" },
  { value: 3, label: "Mar" },
  { value: 4, label: "Apr" },
  { value: 5, label: "May" },
  { value: 6, label: "Jun" },
  { value: 7, label: "Jul" },
  { value: 8, label: "Aug" },
  { value: 9, label: "Sep" },
  { value: 10, label: "Oct" },
  { value: 11, label: "Nov" },
  { value: 12, label: "Dec" },
];

export const CHART_COLORS = {
  blue: "#4285F4",
  green: "#34A853",
  yellow: "#FBBC05",
  red: "#EA4335",
  purple: "#AB47BC",
  teal: "#26A69A",
  orange: "#F57C00",
};

export const getInsightStatus = (title: string) => {
  const lowerTitle = title.toLowerCase();
  if (
    lowerTitle.includes("lost") ||
    lowerTitle.includes("never followed") ||
    lowerTitle.includes("decrease")
  )
    return "error";
  if (lowerTitle.includes("increase") || lowerTitle.includes("gained"))
    return "success";
  if (
    lowerTitle.includes("reduce") ||
    lowerTitle.includes("conflict") ||
    lowerTitle.includes("warning")
  )
    return "warning";
  return "info";
};

export const generateYearOptions = () => {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = currentYear - 5; i <= currentYear; i++) {
    years.push(i);
  }
  return years.sort((a, b) => b - a);
};

export const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(amount);
};

export interface FilterProps {
  commonYear: number;
  commonMonth: number | "";
}

export interface WeekOption {
  weekNumber: number;
  label: string;
  start_date: string;
  to_date: string;
}

/** Returns weeks within the given month (Week 1: 1-7, Week 2: 8-14, ...). */
export const getWeeksInMonth = (year: number, month: number): WeekOption[] => {
  const formattedMonth = String(month).padStart(2, "0");
  const monthStart = moment(`${year}-${formattedMonth}-01`);
  const lastDay = monthStart.clone().endOf("month").date();
  const weeks: WeekOption[] = [];
  const dayRanges: [number, number][] = [[1, 7], [8, 14], [15, 21], [22, 28], [29, 31]];
  for (let i = 0; i < dayRanges.length; i++) {
    const [from, to] = dayRanges[i];
    if (from > lastDay) break;
    const endDay = Math.min(to, lastDay);
    const start = monthStart.clone().date(from).format("YYYY-MM-DD");
    const end = monthStart.clone().date(endDay).format("YYYY-MM-DD");
    weeks.push({
      weekNumber: i + 1,
      label: `Week ${i + 1} (${from}-${endDay})`,
      start_date: start,
      to_date: end,
    });
  }
  return weeks;
};

export const getDateRangeFromYearMonthWeek = (
  year: number,
  month: number | "",
  week: number | "",
  weekOptions: WeekOption[],
): { start_date: string; to_date: string } => {
  if (month !== "" && week !== "" && weekOptions.length > 0) {
    const selected = weekOptions.find((w) => w.weekNumber === week);
    if (selected) return { start_date: selected.start_date, to_date: selected.to_date };
  }
  if (month !== "") {
    const formattedMonth = String(month).padStart(2, "0");
    const start = moment(`${year}-${formattedMonth}-01`).startOf("month").format("YYYY-MM-DD");
    const end = moment(`${year}-${formattedMonth}-01`).endOf("month").format("YYYY-MM-DD");
    return { start_date: start, to_date: end };
  }
  const start = moment(`${year}-01-01`).startOf("year").format("YYYY-MM-DD");
  const end = moment(`${year}-12-31`).endOf("year").format("YYYY-MM-DD");
  return { start_date: start, to_date: end };
};
